import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const contacts: AppRouteModule = {
  path: '/contacts',
  name: 'Contacts',
  component: LAYOUT,
  redirect: '/contacts/index',
  meta: {
    icon: 'material-symbols:contact-page-outline',
    title: '联系人',
    hideChildrenInMenu: true,
    auth: 'contacts',
    orderNo: 30,
  },
  children: [
    {
      path: 'index',
      name: 'ContactsIndex',
      component: () => import('/@/views/admin/contacts/index.vue'),
      meta: {
        title: '联系人列表',
        hideMenu: true,
        ignoreKeepAlive: false,
        setting: {
          action: 'index',
          controller: 'contacts',
          module: 'crm',
          types: 'crm_contacts',
        },
        auth: 'contacts.index',
      },
    },
    {
      path: 'detail/:id',
      name: 'ContactsDetail',
      component: () => import('/@/views/admin/contacts/ContactsDetail.vue'),
      meta: {
        title: '联系人详情',
        ignoreKeepAlive: true,
        hideMenu: true,
        currentActiveMenu: '/contacts/index',
        setting: {
          action: 'read',
          controller: 'contacts',
          module: 'crm',
          types: 'crm_contacts',
        },
        auth: 'contacts.read',
      },
    },
  ],
};

export default contacts;
